import { all, fork } from 'redux-saga/effects';
import {
  darftCountSaga,
  docListSaga,
  trashDocSaga,
  unTrashDocSaga,
  staffDocumentChartSaga,
  clientDocumentChartSaga,
  BillingDocumentChartSaga,
  getDocumenByIdSaga,
  docBillingHistorySaga,
  checkComplianceSaga,
  getDocumenBillingActionSaga,
  getDocumentServiceListSaga,
  updateDocumentServiceSaga,
  getPlaceOfServiceSaga,
  updatePlaceOfServicePayloadSaga,
  getRiskDDLSaga,
  getRiskFactorDDLSaga,
  getRiskProtectiveDDLSaga,
  getLatestDocumentByTemplateIdSaga,
  getStaffListActiveInactiveSaga,
  BillingByPayerSaga,
  updateDocumentServiceDateSaga,
  updateDocumentDiagnosisSaga,
  updateDocumentSiteOfServiceSaga,
  metricsByStatusSaga,
  metricsByTemplateSaga,
  metricsBySiteSaga,
  metricsByServiceCodeSaga,
  metricsByServiceCodeWithModifierSaga,
  getDocSuperBillSaga,
  getDocTemplateTypeSaga,
  getDocAttachmentSaga,
  removeDocUnitsSaga,
  recalculateDocUnitsSaga,
  mileagePayRateSaga,
  getClientsMedicationSaga,
  getClientPrintedDocumentsSaga,
  deleteClientPrintedDocumentsSaga,
  applyBatchSignToDocSaga,
  getCapNoteGoalSaga,
  getCapNoteInterventionSaga,
  getCapNoteAssessmentSaga,
  getClinicDocumentSettingsSaga,
  getCapNotesReportSaga,
  exportDocumentReportSaga
} from './docs.Saga';
import { LoginSaga, getAuthViewTransSaga, getRoleSaga, getStaffSettingsSaga, updateServiceBatchEndDateSaga, updateAuthBatchEndDateSaga, insertAuthServiceReviewsRequestSaga, getAuthServiceReviewsRequestSaga, } from './auth.Saga';
import { getClientListSaga, getServiceListSaga, getSiteListSaga, getStaffListSaga } from './docs.Saga';
import { clinicLogoSaga } from './settings.Saga';
import { checkDuplicateClientSaga, clientBillingClaimSaga, completeComplianceSaga, deleteManuallyCompletedComplianceSaga, deleteReviewGoalSaga, getClientComplianceListSaga, getClientStatusSaga, getClinicFlagSaga, getMultiClientListSaga, getReviewGoalByGoalIdSaga, getTpStaffTypesDllSaga, getUnreadCountSaga, insertReviewGoalSaga, saveAssignFlagToClientSaga, saveSelectedClientEligibilitySaga, saveSelectedClientStatusSaga, getClientLedgerByClientIdSaga, insertClientLedgerRecordSaga, deleteClientLedgerRecordSaga, getPaymentTypesClientLedgerSaga, getClientLedgerByIdSaga, getCurrentLedgerBalanceSaga, updateClientLedgerSaga, getClientAuditSaga, getDocForComplianceSaga, getClientPortalAccountAccessSaga, createAccForCPSaga, updateAccForCPSaga, getAccCPDetailSaga, resetAccPwdSaga, deleteClientMedicationSaga, updateClientMedicationSaga, insertClientMedicationSaga, getClientMedicationByClientIdSaga, getClientMedicationByIdSaga, insertSocialDeterminantsSaga, getSocialDeterminantsSaga, updateSocialDeterminantsSaga, getContactTypeListSaga, getCollateralContactSaga, insertCollateralContactInfoSaga, updateCollateralContactInfoSaga, deleteCollateralContactSaga, getCollateralContactByIdSaga, getClientDocAttachmentSaga, getComplianceAuditHistorySaga, getPosListSaga, referralSourceDeleteSaga, referralProviderDeleteSaga, getMinServiceReportSaga, reactivateTPSaga, getCpFileForTP, getFileUrlSaga, uploadTreatmentSaga, updateRecordFileCreatedSaga, getPrintedFilesSaga, getFileForSelectedTreatmentPlanSaga, getGenderIdenditySaga, getSexualOrientationSaga, getMaritalStatusSaga, searchTpFileSaga, getClientMedicalHistorySaga, insertClientMedicalHistorySaga, updateClientMedicalHistorySaga, deleteClientMedicalHistorySaga, getFamilyMedicalHistorySaga, insertFamilyMedicalHistorySaga, deleteFamilyMedicalHistorySaga, getClientMajorMedicalIssueSaga, insertClientMajorMedicalIssueSaga, deleteClientMajorMedicalIssueSaga, sendQuestionnaireToClientSaga, getClientQuestionnaireByIdSaga, getServiceRuleUtilizationReportSaga, getTreatmentPlanAuditLogSaga, getClientTreatmentPlanSaga, duplicateTPSaga, getCAPServiceSaga ,getGenderListSaga,getStateListSaga, updateGoalDatesSaga, getClientParentInfoSaga, getClientAssignedStaffSaga, getDiagnosisEducationSaga, GetClientContactInformationSaga, GetClientContactInformationByEventSaga, deleteClientSaga, SendTelehealthLinkToProvidedContactSaga, getMedicationEducationSaga, getTreatmentPlansSaga} from './client.Saga';
import { AssignSetToClientSaga, AssignSetToStaffSaga, GetServiceDDLByClinicIdSaga, InsertServiceSetSaga, SaveDefaultGoalTemplatetSaga, UpdateServiceSetSaga, assignCliniTagsSaga, assignDefaultGoalsToClientSaga, createNewAuthSaga, deleteAuthSetSaga, deleteClinicDefaultGoalsSaga, deleteClinicDocumentSaga, deleteClinicDocumentTagSaga, deleteDefaultGoalTemplateSetSaga, deleteServiceSetSaga, getAuthSetListSaga, getClientComplianceByIdSaga, getClientComplianceForClinicDDLSaga, getClientComplianceSaga, getCliniTagsSaga, getClinicDefaultGoalsSaga, getClinicDefaultGoalsTemplatesSaga, getClinicDocumentByIdSaga, getClinicDocumentS3SignedUrlSaga, getClinicServiceListSaga, getClinicStoredDocumentByClinicSaga, getDocumentTemplateSaga, getGoalByIdSaga, getServiceSetsSaga, updateAuthSetSaga, updateClinicDefaultGoalsTemplateSaga, insertClinicianSaga, getClinicianListSaga, getClinicNotificationSettingSaga, saveClinicNotificationSettingPayloadSaga, getClinicNewAuthAlertSettingSaga, assignNotificationSettingPayloadSaga, storeComplianceReportDataSaga, getRoleListSaga, getAssignedRolesForNotificationSettingsSaga, getClinicTpServiceTypesSaga, getClinicTpStaffTypesSaga, insertOrUpdateClinicTpServiceTypesSaga, deleteClinicTpServiceTypesSaga, insertOrUpdateClinicTpStaffTypesSaga, deleteClinicTpStaffTypesSaga, AssignCertificateToStaffSaga, getCalenderCategorySaga, insertCalendarCategorySaga, updateCalendarCategorySaga, deleteCalendarCategorySaga, getDefaultCalendarCategoriesSaga, updateDefaultCalendarCategoriesSaga, getClientsForCaseloadMapSaga, GetDefaultStaffGoalsSaga, GetDefaultStaffGoalsByIdSaga, AssignDefaultGoalsToStaffSaga, InsertDefaultStaffGoalSaga, UpdateDefaultStaffGoalSaga, DeleteDefaultStaffGoalSaga, getImplementationCheckListSaga, updateImplementationCheckListSaga, getClinicDetailsSaga, getServiceAuditLogSaga, getClientStoredDocSaga } from './clinic.saga';

import { billingClaimServiceLineSaga, getEdiByBatchIdSaga, getbillingTransItemClaimIdSaga, updateTransSrvLineBillingStatusSaga, getBillingStatusSaga, getCms1500ByClaimIdSaga, getCms1500ForBatchSaga, get837ClaimByIdSaga, saveRemittanceDataSaga, getFullRemittanceByIdSaga, getbillingSubReportBySiteSaga, getbillingSubReportByPayerSaga, GetBillingRemittanceReportBySiteSaga, GetBillingRemittanceReportByPayerSaga,updateClaimLevelBillingStatusSaga, getAgingReportSaga } from './billing.Saga';
import { getBillingCountSaga, getClientByGenderCountSaga, getClientCountSaga, getClockStatusSaga, getServiceUnitsRenderSaga, getTimeClockByIdSaga, saveTaskFilterSaga, updateTImeClockSaga, updateTimeClockByIdSaga, getTimeClockArchiveByIdSaga, getTrainingLinksSaga, getUpcomingAppointmentsSaga, getUpcomingComplianceCountDataSaga, getInsuranceTypesSaga, updateCustomRoleSaga, getCurrentTasksSaga, updateTaskStatusValueSaga, getAnnouncementsSaga, getAnnouncementsByIdSaga, deleteAnnouncementsSaga, saveAnnouncementsListSaga, updateAnnouncementsListSaga, getDischargeReasonsSaga, getServiceRuleExpectedUsageSaga, getDashboardCardSettingSaga, updateDashboardCardSetting, GetStaffDashBoardCardMyTimeSaga } from './dashboard.Saga';

import { GetServiceSetDDLSaga, GetStaffNotificationSettingSaga, GetStaffTaskNotificationSettingSaga, GetStaffNewNotificationSettingSaga, SaveStaffNotificationSaga, GetStaffNotificationMediumSettingSaga, SaveStaffNotificationMediumSaga, SaveStaffCredentialInfoSaga, DeleteStaffCredentialSaga, GetStaffCredentialListSaga, updateStaffCredentialSaga, getStaffAuditLogSaga, assignAdditionalClientsToStaffSaga, assignStaffToSiteSaga, exportCaseloadReportToExcelSaga, getStaffCommentSaga, addUpdateStaffCommentSaga, getStaffReportSaga, getAllStaffReportSaga, postStaffReportSaga, getReportTypesSaga, getReportsByReportTypeSaga, getReportColumnsSaga, getRoleReportsSaga, assignReportsToRoleSaga, getStaffReportColumnPreferencesSaga, insertStaffReportColPreferencesSaga, assignReportToMultipleStaffSaga, getAssignedStaffOfReportSaga, getStaffReportWithTypesSaga, GetStaffSchedulerNotificationSettingSaga, getStaffServiceReportByStaffIdSaga, getStaffDDLByClinicIdSaga, assignTemplatesToStaffSaga, GetStaffMessageNotificationSettingSaga } from './staff.Saga';
import { getComplianceReportSaga } from './compliance.saga';
import { storeComplianceReport } from '../actions';
import { LockUnlockDocumentsSaga } from './docs.Saga';
import { ApproveOrDisapproveDocumentsSaga} from './docs.Saga';
import { applyDocSignatureSaga, deleteAttachmentSaga, getAllSkillsSaga, getDocTemplatePrefsSaga, getStaffDocAttachmentSaga, getStaffDocByIdSaga, getStaffDocListSaga, getStaffDocSaga, getStaffDocSignatureSaga, getStaffGoalsSaga, getStaffTemplatesSaga, insertDocSaga, updateDocSaga } from './staffDocs.Saga';
import { deleteServiceRuleSaga, getServiceRuleListSaga, insertServiceRuleSaga, updateServiceRuleSaga, deleteMinServiceRuleSaga, getMinServiceRuleListSaga, insertMinServiceRuleSaga, updateMinServiceRuleSaga } from './service.Saga';
import { getAuditLogSaga, getClinicReminderSettingsSaga, getClinicsSitesSaga, getGlobalClinicsSitesSaga, insertPhoneSettingSaga, insertReminderEmailSettingsSaga, insertReminderSettingsSaga, insertTextSettingSaga } from './clinic.reminders.saga';
import { deleteClientMessageLabelSaga, getClientMessageLabelSaga, moveClientMessageSaga, saveClientMessageLabelSaga, updateClientMessageLabelSaga } from './messaging.Saga';
import { GetStaffCredentialsReportSaga, getClientGeneralReportsSaga, getClientServiceRuleReportsSaga, getGoalsReportSaga, getTeleahealthLogsSaga } from './report.Saga';
import { attachPaymentMethodSaga, getClientSubsCriptionsSaga, getCustomerInvoicesSaga, getPaymentMethodsSaga, getStripeCustomerSaga, updateDefaultMethodSaga } from './subscription-manager.Saga';
import { deleteCalendarEventTitleSaga, getCalendarEventTitleSaga, insertCalendarEventTitleSaga, updateCalendarEventTitleSaga } from './calendar.setting.saga';


export function* rootSaga() {
  yield all([
    fork(LoginSaga),
    fork(getStaffSettingsSaga),
    fork(getRoleSaga),
    fork(darftCountSaga),
    fork(trashDocSaga),
    fork(unTrashDocSaga),
    fork(docListSaga),
    fork(clinicLogoSaga),
    fork(staffDocumentChartSaga),
    fork(clientDocumentChartSaga),
    fork(BillingDocumentChartSaga),
    fork(getClientListSaga),
    fork(getStaffListSaga),
    fork(getServiceListSaga),
    fork(getSiteListSaga),
    fork(clientBillingClaimSaga),
    fork(getDocumenByIdSaga),
    fork(getClientComplianceSaga),
    fork(getClinicServiceListSaga),
    fork(getDocumentTemplateSaga),
    fork(getClientComplianceForClinicDDLSaga),
    fork(billingClaimServiceLineSaga),
    fork(getClientComplianceByIdSaga),
    fork(docBillingHistorySaga),
    fork(getClientComplianceListSaga),
    fork(completeComplianceSaga),
    fork(deleteManuallyCompletedComplianceSaga),
    fork(checkComplianceSaga),
    fork(getClinicFlagSaga),
    fork(saveAssignFlagToClientSaga),
    fork(getClientStatusSaga),
    fork(saveSelectedClientStatusSaga),
    fork(saveSelectedClientEligibilitySaga),
    fork(getUnreadCountSaga),
    fork(getMultiClientListSaga),
    fork(getbillingTransItemClaimIdSaga),
    fork(getClinicDefaultGoalsSaga),
    fork(deleteClinicDefaultGoalsSaga),
    fork(assignDefaultGoalsToClientSaga),
    fork(getGoalByIdSaga),
    fork(getClientCountSaga),
    fork(getServiceSetsSaga),
    fork(deleteServiceSetSaga),
    fork(InsertServiceSetSaga),
    fork(AssignSetToStaffSaga),
    fork(UpdateServiceSetSaga),
    fork(getServiceUnitsRenderSaga),
    fork(getBillingCountSaga),
    fork(GetServiceDDLByClinicIdSaga),
    fork(GetServiceSetDDLSaga),
    fork(getComplianceReportSaga),
    fork(getAuthSetListSaga),
    fork(deleteAuthSetSaga),
    fork(createNewAuthSaga),
    fork(updateAuthSetSaga),
    fork(getDocumenBillingActionSaga),
    fork(SaveDefaultGoalTemplatetSaga),
    fork(getClinicDefaultGoalsTemplatesSaga),
    fork(deleteDefaultGoalTemplateSetSaga),
    fork(updateClinicDefaultGoalsTemplateSaga),
    fork(AssignSetToClientSaga),
    fork(getClinicStoredDocumentByClinicSaga),
    fork(getClinicDocumentS3SignedUrlSaga),
    fork(deleteClinicDocumentSaga),
    fork(deleteClinicDocumentTagSaga),
    fork(getClinicDocumentByIdSaga),
    fork(getCliniTagsSaga),
    fork(assignCliniTagsSaga),
    fork(insertClinicianSaga),
    fork(getClinicianListSaga),
    fork(saveTaskFilterSaga),
    fork(getTpStaffTypesDllSaga),
    fork(getEdiByBatchIdSaga),
    fork(insertReviewGoalSaga),
    fork(getReviewGoalByGoalIdSaga),
    fork(deleteReviewGoalSaga),
    fork(GetStaffNotificationSettingSaga),
    fork(GetStaffTaskNotificationSettingSaga),
    fork(GetStaffSchedulerNotificationSettingSaga),
    fork(GetStaffMessageNotificationSettingSaga),
    fork(GetStaffNewNotificationSettingSaga),
    fork(SaveStaffNotificationSaga),
    fork(getClinicNotificationSettingSaga),
    fork(saveClinicNotificationSettingPayloadSaga),
    fork(getClinicNewAuthAlertSettingSaga),
    fork(getAuthViewTransSaga),
    fork(getClockStatusSaga),
    fork(updateTImeClockSaga),
    fork(assignNotificationSettingPayloadSaga),
    fork(getRoleListSaga),
    fork(storeComplianceReport),
    fork(storeComplianceReportDataSaga),
    fork(getDocumentServiceListSaga),
    fork(updateDocumentServiceSaga),
    fork(updateDocumentServiceDateSaga),
    fork(updateDocumentDiagnosisSaga),
    fork(updateDocumentSiteOfServiceSaga),
    fork(getPlaceOfServiceSaga),
    fork(updatePlaceOfServicePayloadSaga),
    fork(getRiskDDLSaga),
    fork(GetStaffNotificationMediumSettingSaga),
    fork(SaveStaffNotificationMediumSaga),
    fork(getAssignedRolesForNotificationSettingsSaga),
    fork(getTimeClockByIdSaga),
    fork(updateTimeClockByIdSaga),
    fork(getClientByGenderCountSaga),
    fork(getLatestDocumentByTemplateIdSaga),
    fork(getRiskFactorDDLSaga),
    fork(getRiskProtectiveDDLSaga),
    fork(getStaffListActiveInactiveSaga),
    fork(getClinicTpServiceTypesSaga),
    fork(getClinicTpStaffTypesSaga),
    fork(insertOrUpdateClinicTpServiceTypesSaga),
    fork(deleteClinicTpServiceTypesSaga),
    fork(insertOrUpdateClinicTpStaffTypesSaga),
    fork(deleteClinicTpStaffTypesSaga),
    fork(BillingByPayerSaga),
    fork(checkDuplicateClientSaga),
    fork(LockUnlockDocumentsSaga),
    fork(ApproveOrDisapproveDocumentsSaga),
    fork(getTimeClockArchiveByIdSaga),
    fork(AssignCertificateToStaffSaga),
    fork(getStaffTemplatesSaga),
    fork(getStaffDocListSaga),
    fork(getDocTemplatePrefsSaga),
    fork(getStaffGoalsSaga),
    fork(getAllSkillsSaga),
    fork(insertDocSaga),
    fork(getStaffDocSaga),
    fork(getStaffDocByIdSaga),
    fork(getStaffDocSignatureSaga),
    fork(getStaffDocAttachmentSaga),
    fork(updateDocSaga),
    fork(applyDocSignatureSaga),
    fork(getTrainingLinksSaga),
    fork(getCalenderCategorySaga),
    fork(insertCalendarCategorySaga),
    fork(updateCalendarCategorySaga),
    fork(deleteCalendarCategorySaga),
    fork(getDefaultCalendarCategoriesSaga),
    fork(updateDefaultCalendarCategoriesSaga),
    fork(metricsByStatusSaga),
    fork(metricsByTemplateSaga),
    fork(deleteAttachmentSaga),
    fork(getServiceRuleListSaga),
    fork(deleteServiceRuleSaga),
    fork(insertServiceRuleSaga),
    fork(updateServiceRuleSaga),
    fork(getUpcomingAppointmentsSaga),
    fork(getUpcomingComplianceCountDataSaga),
    fork(metricsByServiceCodeSaga),
    fork(metricsByServiceCodeWithModifierSaga),
    fork(metricsBySiteSaga),
    fork(getDocSuperBillSaga),
    fork(getClientLedgerByClientIdSaga),
    fork(insertClientLedgerRecordSaga),
    fork(deleteClientLedgerRecordSaga),
    fork(getPaymentTypesClientLedgerSaga),
    fork(getClientLedgerByIdSaga),
    fork(SaveStaffCredentialInfoSaga),
    fork(DeleteStaffCredentialSaga),
    fork(GetStaffCredentialListSaga),
    fork(updateStaffCredentialSaga),
    fork(getCurrentLedgerBalanceSaga),
    fork(updateClientLedgerSaga),
    fork(getStaffAuditLogSaga),
    fork(getClientAuditSaga),
    fork(assignAdditionalClientsToStaffSaga),
    fork(assignStaffToSiteSaga),
    fork(getDocForComplianceSaga),
    fork(getClinicsSitesSaga),
    fork(getClinicReminderSettingsSaga),
    fork(insertReminderSettingsSaga),
    fork(insertReminderEmailSettingsSaga),
    fork(insertPhoneSettingSaga),
    fork(insertTextSettingSaga),
    fork(getClientPortalAccountAccessSaga),
    fork(getAuditLogSaga),
    fork(createAccForCPSaga),
    fork(updateAccForCPSaga),
    fork(getAccCPDetailSaga),
    fork(resetAccPwdSaga),
    fork(deleteClientMedicationSaga),
    fork(updateClientMedicationSaga),
    fork(insertClientMedicationSaga),
    fork(getClientMedicationByClientIdSaga),
    fork(getClientMedicationByIdSaga),
    fork(exportCaseloadReportToExcelSaga),
    fork(getDocTemplateTypeSaga),
    fork(getInsuranceTypesSaga),
    fork(insertSocialDeterminantsSaga),
    fork(getSocialDeterminantsSaga),
    fork(updateSocialDeterminantsSaga),
    fork(getGlobalClinicsSitesSaga),
    fork(updateCustomRoleSaga),
    fork(getDocAttachmentSaga),
    fork(getClientMessageLabelSaga),
    fork(saveClientMessageLabelSaga),
    fork(updateClientMessageLabelSaga),
    fork(deleteClientMessageLabelSaga),
    fork(moveClientMessageSaga),
    fork(getContactTypeListSaga),
    fork(getCollateralContactSaga),
    fork(insertCollateralContactInfoSaga),
    fork(updateCollateralContactInfoSaga),
    fork(deleteCollateralContactSaga),
    fork(getCollateralContactByIdSaga),
    fork(getClientDocAttachmentSaga),
    fork(getComplianceAuditHistorySaga),
    fork(removeDocUnitsSaga),
    fork(recalculateDocUnitsSaga),
    fork(updateTransSrvLineBillingStatusSaga),
    fork(getBillingStatusSaga),
    fork(getPosListSaga),
    fork(getStaffCommentSaga),
    fork(addUpdateStaffCommentSaga),
    fork(referralSourceDeleteSaga),
    fork(referralProviderDeleteSaga),
    fork(getMinServiceRuleListSaga),
    fork(deleteMinServiceRuleSaga),
    fork(insertMinServiceRuleSaga),
    fork(updateMinServiceRuleSaga),
    fork(getCms1500ByClaimIdSaga),
    fork(getCms1500ForBatchSaga),
    fork(getMinServiceReportSaga),
    fork(getStaffReportSaga),
    fork(getAllStaffReportSaga),
    fork(postStaffReportSaga),
    fork(getCurrentTasksSaga),
    fork(updateTaskStatusValueSaga),
    fork(getReportTypesSaga),
    fork(getReportsByReportTypeSaga),
    fork(getReportColumnsSaga),
    fork(getRoleReportsSaga),
    fork(assignReportsToRoleSaga),
    fork(getStaffReportColumnPreferencesSaga),
    fork(insertStaffReportColPreferencesSaga),
    fork(getAssignedStaffOfReportSaga),
    fork(assignReportToMultipleStaffSaga),
    fork(getStaffReportWithTypesSaga),
    fork(getClientsForCaseloadMapSaga),
    fork(getAnnouncementsSaga),
    fork(getAnnouncementsByIdSaga),
    fork(deleteAnnouncementsSaga),
    fork(saveAnnouncementsListSaga),
    fork(updateAnnouncementsListSaga),
    fork(getClientGeneralReportsSaga),
    fork(mileagePayRateSaga),
    fork(updateAuthBatchEndDateSaga),
    fork(updateServiceBatchEndDateSaga),
    fork(reactivateTPSaga),
    fork(getClientSubsCriptionsSaga),
    fork(getPaymentMethodsSaga),
    fork(getCustomerInvoicesSaga),
    fork(get837ClaimByIdSaga),
    fork(saveRemittanceDataSaga),
    fork(getClientsMedicationSaga),
    fork(attachPaymentMethodSaga),
    fork(getStripeCustomerSaga),
    fork(updateDefaultMethodSaga),
    fork(getFullRemittanceByIdSaga),
    fork(getClientPrintedDocumentsSaga),
    fork(deleteClientPrintedDocumentsSaga),
    fork(getDischargeReasonsSaga),
    fork(getStaffServiceReportByStaffIdSaga),
    fork(getDischargeReasonsSaga),
    fork(getCpFileForTP),
    fork(getFileUrlSaga),
    fork(uploadTreatmentSaga),
    fork(updateRecordFileCreatedSaga),
    fork(getPrintedFilesSaga),
    fork(getFileForSelectedTreatmentPlanSaga),
    fork(getGenderIdenditySaga),
    fork(getSexualOrientationSaga),
    fork(getMaritalStatusSaga),
    fork(getServiceRuleExpectedUsageSaga),
    fork(searchTpFileSaga),
    fork(getClientMedicalHistorySaga),
    fork(insertClientMedicalHistorySaga),
    fork(updateClientMedicalHistorySaga),
    fork(deleteClientMedicalHistorySaga),
    fork(getFamilyMedicalHistorySaga),
    fork(insertFamilyMedicalHistorySaga),
    fork(deleteFamilyMedicalHistorySaga),
    fork(searchTpFileSaga),
    fork(getClientServiceRuleReportsSaga),
    fork(getClientMajorMedicalIssueSaga),
    fork(insertClientMajorMedicalIssueSaga),
    fork(deleteClientMajorMedicalIssueSaga),
    fork(getStaffDDLByClinicIdSaga),
    fork(sendQuestionnaireToClientSaga),
    fork(getbillingSubReportByPayerSaga),
    fork(getbillingSubReportBySiteSaga),
    fork(getClientQuestionnaireByIdSaga),
    fork(GetBillingRemittanceReportBySiteSaga),
    fork(GetBillingRemittanceReportByPayerSaga),
    fork(getServiceRuleUtilizationReportSaga),
    fork(getTeleahealthLogsSaga),
    fork(getTreatmentPlanAuditLogSaga),
    fork(getClientTreatmentPlanSaga),
    fork(duplicateTPSaga),
    fork(getDashboardCardSettingSaga),
    fork(updateDashboardCardSetting),
    fork(getCAPServiceSaga),
    fork(applyBatchSignToDocSaga),
    fork(getCapNoteGoalSaga),
    fork(getCapNoteInterventionSaga),
    fork(getCapNoteAssessmentSaga),
    fork(getCalendarEventTitleSaga),
    fork(insertCalendarEventTitleSaga),
    fork(updateCalendarEventTitleSaga),
    fork(deleteCalendarEventTitleSaga),
    fork(getClinicDocumentSettingsSaga),
    fork(getGenderListSaga),
    fork(getStateListSaga),
    fork(updateClaimLevelBillingStatusSaga),
    fork(getCapNotesReportSaga),
    fork(getImplementationCheckListSaga),
    fork(updateImplementationCheckListSaga),
    fork(getClinicDetailsSaga),
    fork(GetDefaultStaffGoalsSaga),
    fork(GetDefaultStaffGoalsByIdSaga),
    fork(AssignDefaultGoalsToStaffSaga),
    fork(InsertDefaultStaffGoalSaga),
    fork(UpdateDefaultStaffGoalSaga),
    fork(DeleteDefaultStaffGoalSaga),
    fork(assignTemplatesToStaffSaga),
    fork(insertAuthServiceReviewsRequestSaga),
    fork(getGoalsReportSaga),
    fork(getAuthServiceReviewsRequestSaga),
    fork(getServiceAuditLogSaga),
    fork(updateGoalDatesSaga),
    fork(GetStaffDashBoardCardMyTimeSaga),
    fork(getClientParentInfoSaga),
    fork(getClientAssignedStaffSaga),
    fork(getDiagnosisEducationSaga),
    fork(getMedicationEducationSaga),
    fork(deleteClientSaga),
    fork(GetClientContactInformationSaga),
    fork(GetClientContactInformationByEventSaga),
    fork(SendTelehealthLinkToProvidedContactSaga),
    fork(GetStaffCredentialsReportSaga),
    fork(exportDocumentReportSaga),
    fork(getClientStoredDocSaga),
    fork(getTreatmentPlansSaga),
    fork(getAgingReportSaga)
  ]);
}
